var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_816_3571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0C4.25315 0 0 4.25315 0 9.5C0 14.7468 4.25315 19 9.5 19C14.7468 19 19 14.7468 19 9.5C19 4.25315 14.7468 0 9.5 0Z",
    fill: "url(#paint0_linear_816_3571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8686 13.3459H13.4467L13.8517 10.7269H10.8686V9.29539C10.8686 8.20756 11.2242 7.24276 12.2418 7.24276H13.8771V4.95751C13.5897 4.91866 12.982 4.83398 11.8339 4.83398C9.4361 4.83398 8.03049 6.10013 8.03049 8.98508V10.7274H5.56543V13.3464H8.02999V20.5448C8.51812 20.6175 9.01272 20.6673 9.52028 20.6673C9.97902 20.6673 10.4268 20.6255 10.8686 20.5657V13.3459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_816_3571",
    x1: 2.84667,
    y1: 2.84667,
    x2: 17.3921,
    y2: 17.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_816_3571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.1d95e67990ef248e705b6a5217f6ea3a.svg";
export { ForwardRef as ReactComponent };